import { baseColors } from "@Constants/baseStyles"
import * as React from "react"
import Svg, { Path } from "react-native-svg"

const SvgSettingsActive = (props) => {
    return (
        <Svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} fill="none" viewBox="0 0 20 20" {...props}>
            <Path
                fill={baseColors.orange.primary}
                d="M17.251 7.755l-.505-1.2s1.175-2.65 1.071-2.752l-1.555-1.519c-.108-.104-2.759 1.106-2.759 1.106l-1.223-.494S11.2.209 11.052.209H8.857c-.153 0-1.152 2.692-1.152 2.692l-1.221.496s-2.707-1.15-2.81-1.048L2.12 3.87c-.108.105 1.128 2.702 1.128 2.702L2.743 7.77S0 8.826 0 8.969v2.15c0 .15 2.75 1.13 2.75 1.13l.505 1.196s-1.174 2.648-1.071 2.75l1.554 1.522c.106.103 2.758-1.107 2.758-1.107l1.224.496S8.8 19.79 8.949 19.79h2.195c.152 0 1.152-2.692 1.152-2.692l1.225-.496s2.701 1.15 2.806 1.05l1.554-1.52c.109-.107-1.13-2.702-1.13-2.702l.504-1.198S20 11.174 20 11.03V8.88c0-.149-2.749-1.125-2.749-1.125zM13.207 10c0 1.73-1.439 3.137-3.207 3.137-1.765 0-3.206-1.408-3.206-3.137 0-1.73 1.44-3.136 3.207-3.136 1.768 0 3.206 1.406 3.206 3.136z"
            />
        </Svg>
    )
}

export default SvgSettingsActive
